import React from 'react';
import { Link } from 'react-router-dom';
import './ContactUs.css';

const ContactUs = () => {
    return (
        <div className="contact-us-container">
            {/* Back to Home Button */}
            <div className="back-to-home-wrapper">
                <Link to="/" className="back-to-home-link">
                    <svg
                        className="back-arrow"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M15 19l-7-7 7-7"
                        />
                    </svg>
                    Back to Home
                </Link>
            </div>

            {/* Contact Us Header */}
            <div className="contact-us-header">
                <h1 className="contact-us-title">Contact Us</h1>
                <p className="contact-us-subtitle">
                    We'd love to hear from you. Get in touch with the <span style={{ fontWeight: 'bold', color: 'black' }}>Procart team.</span>
                </p>
            </div>

            {/* Contact Information Grid */}
            <div className="contact-grid">
                {/* Our Location */}
                <div className="contact-card">
                    <div className="card-header">
                        <div className="icon-circle red">
                            <svg
                                className="card-icon"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        </div>
                        <h3 className="card-title">Our Location</h3>
                    </div>
                    <p className="card-content">

                        No.48/58, 1st floor, Chunchgatta Main Rd, <br />
                        JP Nagar 7th Phase, Konanakunte, Bengaluru,<br />
                        Karnataka - 560062


                    </p>
                </div>

                {/* Phone */}
                <div className="contact-card">
                    <div className="card-header">
                        <div className="icon-circle red">
                            <svg
                                className="card-icon"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"
                                />
                            </svg>
                        </div>
                        <h3 className="card-title">Phone</h3>
                    </div>
                    <p className="card-content">
                        Customer Support: +91 8722237574 <br />
                        Working Hours: 7:00 AM - 10:00 PM, All days
                    </p>
                </div>

                {/* Email Us */}
                <div className="contact-card">
                    <div className="card-header">
                        <div className="icon-circle red">
                            <svg
                                className="card-icon"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"
                                />
                                <path
                                    d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"
                                />
                            </svg>
                        </div>
                        <h3 className="card-title">Email Us</h3>
                    </div>
                    <p className="card-content">
                        General Inquiries: official.spherex@gmail.com <br />
                    </p>
                </div>

                {/* WhatsApp Support */}
                <div className="contact-card">
                    <div className="card-header">
                        <div className="icon-circle red">
                            <svg
                                className="card-icon"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M10 0C4.477 0 0 4.477 0 10c0 1.665.414 3.24 1.15 4.62L0 20l5.38-1.15A9.962 9.962 0 0010 20c5.523 0 10-4.477 10-10S15.523 0 10 0zm3.3 13.8c-.15.427-.77.71-1.15.85-.427.15-.986.213-1.59-.106-.64-.32-1.387-.853-1.915-1.383-.533-.533-.906-1.12-1.12-1.706-.213-.586-.107-1.12.16-1.546.133-.213.266-.426.426-.533.16-.107.32-.16.533-.16h.373c.16 0 .293.053.426.266 0 0 .533 1.12.64 1.333.107.213.16.426-.053.64-.213.213-.32.32-.533.533-.213.213-.426.426-.32.693.107.266.48.906.906 1.387.426.48.906.853 1.387.906.266.053.533-.053.693-.320l.533-.533c.16-.16.32-.213.533-.107.213.107 1.333.64 1.333.64.213.107.266.32.266.533 0 .160-.053.373-.213.533z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        </div>
                        <h3 className="card-title">WhatsApp Support</h3>
                    </div>
                    <p className="card-content">
                        Quick solutions to your queries via WhatsApp
                    </p>
                    <a
                        href="https://wa.me/918722237574"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="whatsapp-button"
                    >
                        <svg
                            className="whatsapp-icon"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fillRule="evenodd"
                                d="M10 0C4.477 0 0 4.477 0 10c0 1.665.414 3.24 1.15 4.62L0 20l5.38-1.15A9.962 9.962 0 0010 20c5.523 0 10-4.477 10-10S15.523 0 10 0zm3.3 13.8c-.15.427-.77.71-1.15.85-.427.15-.986.213-1.59-.106-.64-.32-1.387-.853-1.915-1.383-.533-.533-.906-1.12-1.12-1.706-.213-.586-.107-1.12.16-1.546.133-.213.266-.426.426-.533.16-.107.32-.16.533-.16h.373c.16 0 .293.053.426.266 0 0 .533 1.12.64 1.333.107.213.16.426-.053.64-.213.213-.32.32-.533.533-.213.213-.426.426-.32.693.107.266.48.906.906 1.387.426.48.906.853 1.387.906.266.053.533-.053.693-.320l.533-.533c.16-.16.32-.213.533-.107.213.107 1.333.64 1.333.64.213.107.266.32.266.533 0 .160-.053.373-.213.533z"
                                clipRule="evenodd"
                            />
                        </svg>
                        Chat with Us
                    </a>
                </div>
            </div>

            {/* Connect with Us Section */}
            <div className="connect-section">
                <div className="connect-content">
                    <h3 className="connect-title">Connect with Us</h3>
                    <div className="social-icons">
                        <a
                            href="https://www.instagram.com/nextech_garage/"
                            className="social-icon instagram"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <svg className="social-icon-svg" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M12 2.04c-5.5 0-9.96 4.46-9.96 9.96 0 4.4 2.86 8.14 6.84 9.46.5.09.68-.22.68-.48 0-.24-.01-.87-.01-1.7-2.78.6-3.37-1.34-3.37-1.34-.45-1.15-1.1-1.46-1.1-1.46-.9-.62.07-.61.07-.61 1 .07 1.53 1.03 1.53 1.03.89 1.53 2.34 1.09 2.91.83.09-.65.35-1.09.63-1.34-2.22-.25-4.55-1.11-4.55-4.94 0-1.09.39-1.98 1.03-2.68-.1-.25-.45-1.27.1-2.65 0 0 .84-.27 2.75 1.02A9.58 9.58 0 0112 6.84c.85.004 1.71.114 2.52.33 1.91-1.29 2.75-1.02 2.75-1.02.55 1.38.2 2.4.1 2.65.64.7 1.03 1.59 1.03 2.68 0 3.84-2.34 4.68-4.57 4.93.36.31.68.92.68 1.85 0 1.34-.01 2.42-.01 2.75 0 .27.18.58.69.48A9.963 9.963 0 0022 12c0-5.5-4.46-9.96-9.96-9.96z" />
                            </svg>
                        </a>

                        <a href="#" className="social-icon linkedin">
                            <svg className="social-icon-svg" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.784-1.75-1.75s.784-1.75 1.75-1.75 1.75.784 1.75 1.75-.784 1.75-1.75 1.75zm13.5 12.268h-3v-5.604c0-1.337-.027-3.063-1.867-3.063-1.867 0-2.153 1.459-2.153 2.966v5.701h-3v-11h2.879v1.526h.041c.401-.761 1.381-1.562 2.841-1.562 3.037 0 3.6 2 3.6 4.604v6.432z" />
                            </svg>
                        </a>
                        <a href="#" className="social-icon twitter">
                            <svg className="social-icon-svg" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-2.717 0-4.92 2.203-4.92 4.917 0 .385.045.762.127 1.124-4.09-.205-7.719-2.165-10.141-5.144-.424.722-.666 1.561-.666 2.457 0 1.694.859 3.188 2.164 4.065-.797-.025-1.548-.245-2.202-.611v.061c0 2.367 1.684 4.342 3.918 4.789-.41.111-.842.171-1.287.171-.314 0-.621-.03-.921-.086.623 1.947 2.431 3.365 4.576 3.403-1.674 1.313-3.779 2.096-6.07 2.096-.394 0-.787-.022-1.173-.066 2.179 1.398 4.768 2.212 7.548 2.212 9.054 0 14.002-7.496 14.002-14.002 0-.213-.005-.426-.014-.637.961-.695 1.797-1.562 2.457-2.549z" />
                            </svg>
                        </a>
                    </div>
                    <p className="connect-text">
                        Follow us on social media for updates, offers, and more!
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;